// Normalisation du prix payé saisi à l'import Tradovate.
//
// Module PUR (aucun import Wasp/React) et volontairement séparé du composant :
// importer TradovateImportReview.tsx depuis un test tire
// `wasp/client/operations`, qui touche `window` et fait échouer la suite sous
// vitest ("window is not defined"). Le garder ici rend la règle testable.

/**
 * Convertit la saisie libre du champ prix en nombre exploitable.
 *
 * Renvoie `null` pour toute saisie vide, non numérique ou négative : le champ
 * est alors traité comme non renseigné (le prix reste modifiable plus tard dans
 * la fiche compte) plutôt que d'envoyer un NaN ou un montant que le serveur
 * rejetterait. Zéro est conservé : un compte offert est un cas légitime.
 *
 * La virgule est acceptée — les claviers FR la produisent et `Number("12,5")`
 * vaut NaN.
 */
export function parseCost(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const value = Number(trimmed.replace(",", "."));
  if (!Number.isFinite(value) || value < 0) return null;
  return value;
}
